import type { BenchmarkReport } from '../../types/benchmark';

interface TokenUsageCardProps {
  report: BenchmarkReport;
}

export function TokenUsageCard({ report }: TokenUsageCardProps) {
  const { token_usage, summary } = report;

  // Handle null/undefined values
  const promptTokens = token_usage?.total_prompt_tokens ?? 0;
  const completionTokens = token_usage?.total_completion_tokens ?? 0;
  const totalTokens = token_usage?.total_tokens ?? 0;
  const avgPromptTokens = token_usage?.avg_prompt_tokens_per_doc ?? 0;
  const avgCompletionTokens = token_usage?.avg_completion_tokens_per_doc ?? 0;
  const estimatedCost = token_usage?.estimated_cost_usd ?? 0;

  const costPerDoc = summary.total_documents > 0
    ? estimatedCost / summary.total_documents
    : 0;

  return (
    <div className="bg-white p-6 border rounded-lg">
      <h3 className="text-lg font-semibold mb-4">Utilisation tokens & Coût</h3>

      <div className="space-y-3">
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-600">Prompt tokens</span>
          <span className="text-sm font-semibold">{promptTokens.toLocaleString()}</span>
        </div>

        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-600">Completion tokens</span>
          <span className="text-sm font-semibold">{completionTokens.toLocaleString()}</span>
        </div>

        <div className="flex justify-between items-center pt-2 border-t">
          <span className="text-sm font-medium text-gray-900">Total tokens</span>
          <span className="text-sm font-bold">{totalTokens.toLocaleString()}</span>
        </div>

        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-600">Moyenne par document</span>
          <span className="text-sm font-semibold">
            {Number(avgPromptTokens).toFixed(0)} + {Number(avgCompletionTokens).toFixed(0)}
          </span>
        </div>

        <div className="mt-4 pt-4 border-t space-y-2">
          <div className="flex justify-between items-center">
            <span className="text-base font-medium text-gray-900">Coût estimé (run)</span>
            <span className="text-xl font-bold text-green-600">
              ${Number(estimatedCost).toFixed(3)}
            </span>
          </div>

          <div className="flex justify-between items-center">
            <span className="text-sm text-gray-600">Coût moyen par document</span>
            <span className="text-sm font-semibold text-green-600">
              ${costPerDoc.toFixed(4)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
